/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rscu_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why are some codons always 1?`)
};

const es_rscu_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué algunos codones siempre son 1?`)
};

const de_rscu_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum sind manche Codons immer 1?`)
};

const nl_rscu_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom zijn sommige codons altijd 1?`)
};

const fr_rscu_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi certains codons sont-ils toujours à 1 ?`)
};

const it_rscu_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché alcuni codoni sono sempre 1?`)
};

const pt_br2_rscu_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que alguns códons são sempre 1?`)
};

const pt_rscu_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que alguns codões são sempre 1?`)
};

const ja_rscu_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`常に1になるコドンがあるのはなぜですか？`)
};

const zh_rscu_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么有些密码子的值始终为 1？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rscu_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rscu_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rscu_faq_q4", locale)
	if (locale === "en") return en_rscu_faq_q4(inputs)
	if (locale === "es") return es_rscu_faq_q4(inputs)
	if (locale === "de") return de_rscu_faq_q4(inputs)
	if (locale === "nl") return nl_rscu_faq_q4(inputs)
	if (locale === "fr") return fr_rscu_faq_q4(inputs)
	if (locale === "it") return it_rscu_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_rscu_faq_q4(inputs)
	if (locale === "pt") return pt_rscu_faq_q4(inputs)
	if (locale === "ja") return ja_rscu_faq_q4(inputs)
	return zh_rscu_faq_q4(inputs)
};